import { Component } from '@angular/core';
interface Image {
  src: string;
  thumbnail: string;
  alt: string;
}
@Component({
  selector: 'app-inclusion-frobel',
  templateUrl: './inclusion-frobel.component.html',
  styleUrls: ['./inclusion-frobel.component.scss'],
})
export class InclusionFrobelComponent {
  images: Image[] = [
    {
      src: 'assets/img/school/inclusion/frobel/1.jpg',
      thumbnail: 'assets/img/school/inclusion/frobel/1.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/inclusion/frobel/2.jpg',
      thumbnail: 'assets/img/school/inclusion/frobel/2.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/inclusion/frobel/3.jpg',
      thumbnail: 'assets/img/school/inclusion/frobel/3.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/inclusion/frobel/4.jpg',
      thumbnail: 'assets/img/school/inclusion/frobel/4.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/inclusion/frobel/5.jpg',
      thumbnail: 'assets/img/school/inclusion/frobel/5.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/inclusion/frobel/6.jpg',
      thumbnail: 'assets/img/school/inclusion/frobel/6.jpg',
      alt: 'Image 01',
    },
  ];
}
